module.exports = __webpack_public_path__ + "static/media/020-Salt Yard.131e6b49.jpg";